module.exports = __webpack_public_path__ + "static/media/yam.fa34f571.png";